import { iShopifyReview } from "../../types/internal";

export const REVIEWER_AVATAR_PASTELS: ReadonlyArray<{ bg: string; fg: string }> = [
    { bg: "#fde2e4", fg: "#9f1239" },
    { bg: "#fce7f3", fg: "#9d174d" },
    { bg: "#ddd6fe", fg: "#5b21b6" },
    { bg: "#cffafe", fg: "#0e7490" },
    { bg: "#d1fae5", fg: "#047857" },
    { bg: "#fef3c7", fg: "#b45309" },
    { bg: "#e0e7ff", fg: "#4338ca" },
    { bg: "#ffedd5", fg: "#c2410c" },
    { bg: "#dbeafe", fg: "#1d4ed8" },
    { bg: "#fae8ff", fg: "#a21caf" },
    { bg: "#ccfbf1", fg: "#0f766e" },
    { bg: "#fecdd3", fg: "#be123c" },
];

export function reviewerInitials(name: string): string {
    const parts = (name || "?").trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    const first = parts[0].charAt(0);
    const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
    return (first + last).toUpperCase();
}

export function reviewerAvatarPastel(name: string, email: string): { bg: string; fg: string } {
    const key = `${name || ""}\0${email || ""}`;
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = key.charCodeAt(i) + ((hash << 5) - hash);
        hash |= 0;
    }
    const idx = Math.abs(hash) % REVIEWER_AVATAR_PASTELS.length;
    return REVIEWER_AVATAR_PASTELS[idx];
}

/** Product pill / meta: prefer Shopify id, else title (API may return id as number). */
export function reviewProductRef(row: Pick<iShopifyReview, "shopify_product_id" | "product_title">): string {
    return (
        String(row.shopify_product_id ?? "").trim() || String(row.product_title ?? "").trim() || ""
    );
}

export function reviewStarCount(stars: string | number | undefined): number {
    return Math.min(5, Math.max(0, Math.round(Number(stars)) || 0));
}
